export const locale = {
    lang: 'en',
    data: {
      'MODALES': {
        'VALIDACION':{
          'ERROR1':'You have question without translate'
        },
        'TITULO': 'An error ocurred',
        'TITULOS': {
          'error': 'An error ocurred',
          'adver': 'Warning',
          'aviso': 'Warning',
          'opSuc': 'Action completed'
        },
        'ACCIONES': {
          'aceptar' : 'Accept',
          'cancelar': 'Cancel',
          'INFORMATIVO': 'Do not show this message again'
        },
        'EXPEDIENTES':{
          'Resultados': 'You do not have the result yet',
          'CARGANDO_COLABORADORES':'Loading collaborators who need medical supervision',
        },
        'MENSAJES': {
          'Something is wrong': 'Something is wrong',
          'password wrong': 'The password you entered is incorrect',
          'User does not exist': 'The email you entered is not registered',
          '150': 'the collabs were saved :V',
          'Error: user already exist': 'The user with this email already exist',
          'CONEX': {
            'SIN': 'Your device has lost internet connection\n\nTo continue using the platform, connect your device to the internet',
            'CON': 'Your device has recovered the internet connection\n\nNow you may continue using the platform'
          },
          'WIZARD': {
            'CERTIFICAR' : {
              'RESTRICCIONES': {
                'rest1': 'To access this section you must set the <b>languages</b> for the survey',
                'rest2': 'To access this section you must complete all the previous steps',
                'rest3': 'To access this section you must <b>schedule</b> the survey launch',
                'rest4': 'To access this section you must have done the <b>mail sending</b> and the survey must have been launched',
                'rest5': 'To access this section you must set the <b>Demographics</b> for the survey'
              },
              'IDIOMAS': {
                'NADA': 'You have not started the languages selection',
                'NADA2': 'yo have notm release date scheduled yet',
                'NADA4': 'You have not started date reminder yet',
                'NODEFAULT': 'You have not selected the main language yet',
                'NOADICIONAL': 'You have no selected any additional language yet',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current languages selection?',
                '210': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can choose the main language and additional languages in which the survey will be presented to the employees',
                'ARCHIVOCOMFIRM': 'Warning! Be sure to work the Excel file on a single operating system to avoid coding conflicts.',
                'BOTONTEXTO':'Understood',
              },
              'NPS': {
                'NADA': 'You have not created any NPS or marked the option without NPS',
                'COMPLETAR': 'Are you sure you can complete the step with your current NPS?',
                '219': 'The step was completed successfully',
                '220': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can modify your NPS for the survey',
                'FALTANTES': 'You have not yet completed filling your NPS'
              },
              'REACTIVOS': {
                'NADA': 'You have not created any statements or marked the option without statements',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current statements?',
                '218': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can add statements to the survey',
                'FALTANTES': 'You have not yet completed filling your statements'
              },
              'FORALL': {
                'NADA': 'You have not finished the 4ALL practices filling yet',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current For All practices?',
                '212': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'This section lists the practices carried out in the company, which involve the participation of all employees',
                'NADA_TRA': 'You have not finished the translate of your 4ALL practices yet',
              },
              'CONTROL': {
                'NADA': 'You have not created any control questions or marked the option without control',
                'COMPLETAR': 'Are you sure you want to complete the step with your current control question?',
                '221': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can modify your survey control question',
                'FALTANTES': 'You have not yet completed filling out your control question'
              },
              'DEMOGRAFICOS': {
                'NADA': 'You have not yet selected demographics',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current demographic information?',
                '213': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'This section establishes the demographic options that will be made available to the employees in the survey'
              },
              'ABIERTAS': {
                'NADA': 'You have not created any open question or marked the option without open questions',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current open questions?',
                '220': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can add open questions to get your employees written feedback',
                'FALTANTES': 'You have not yet completed filling in your open questions'
              },
              'ADICIONALES': {
                'NADA': 'You have not created any additional question or marked the option without additional questions',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current additional questions?',
                '214': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can add custom questions to the survey'
              },
              'COLABORADORES': {
                'NADA': 'You have not loaded your participants database',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current participants database?',
                '211': 'The step was completed successfully',
                '200': 'The step was completed successfully',
                '219': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'This section loads the list of employees to whom the invitation to the survey will be sent via email',
                'ACTUALIZAR': 'Collaborators were correctly added to the survey'
              },
              'PROGRAMACION': {
                'NADA': 'You have not scheduled a date',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current schedule date?',
                '215': 'The step was completed successfully',
                '217': 'The step was completed successfully', //CERTIFICAR2.0
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'This section establishes the dates for launching and sending reminders for the survey completion',
                'INFORMATIVO2': 'This section sets the dates for sending surveys Pulse Check',
                'GUARDA-OK':'The date was successfully saved',
                'OK':'OK',
              },
              'ENVIO': {
                'NADA': 'You have not done the survey invitation email sending to your collaborators yet',
                'COMPLETAR': 'Are you sure to mark this step as completed?',
                '216': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can send the pilot survey invitations'
              },
              'CIERRE': {
                'NADA': 'The survey is not finished yet',
                'COMPLETAR': 'Are you sure to mark this step as completed?',
                '217': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section the current progress of the survey can be consulted, as well as the early closing of the survey',
                'INFORMATIVO2': 'In this section you can check the current progress of each of the Pulse Check surveys launched'
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': 'Warning',
                  'INFO': 'Warning\n\nYour session will be closed and the platform will proceed to login as the selected work center.\n\nDo you confirm to login as the selected work center?',
                  'INFOODS': 'Warning\n\nYour session will be closed and the platform will proceed to login as the selected company.\n\nDo you confirm to login as the selected company?'
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION':'Not yet authorized ',
              'BTN-ENTERADO':'ENTER',
              'MODAL-AUTORIZACION':'Your survey has been sent to validate',


            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': 'It seems that we ran into a technical problem. \n\nWe are working on it to solve it.',
          '102': 'The email address entered is not registered',
          '103': 'The entered password is wrong',
          '101': 'The user with this email already exist'
        }
      }
    }
};
